import Vue from 'vue'
import store from '@store'

const InitMixin = {
  store,
  created() {
    let $main = document.getElementById('app-root');
    this.$store.dispatch('setAssetsRoot', $main.getAttribute('data-assets-root'));
    this.$store.dispatch('mapApi', $main.getAttribute('data-api'));
    this.$store.dispatch('setApiKeys', $main.getAttribute('data-api-keys'));
  }
};

export default InitMixin;
